<template>
    <div class="wineguide-container">
        <div class="itips-head">
            <div class="container">
                <div class="inner-page-title">{{ $t("home-top4") }}</div>
                <div class="inenr-page-breadcrumb">
                    <div class="inner-page-bread-line"></div>
                </div>
            </div>
        </div>
        <div class="container">
            <div class="wine-guide-body">
                <div class="wine-guide-left hide-mobile">
                    <div class="wine-guide-left-title">
                        <nuxt-link class="wine-guide-back" :to="localePath('/wine-guide/usa/sonoma')"></nuxt-link>
                        Producers
                    </div>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/usa/sonoma/ridge-vineyards')">Ridge Vineyards
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/usa/sonoma/sine-qua-non')">Sine Qua Non
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country active"
                               :to="localePath('/wine-guide/usa/sonoma/verite-vigneron')">Verite Vigneron
                    </nuxt-link>
                </div>
                <div class="show-mobile">
                    <div class="wine-guide-left-title">
                        <nuxt-link class="wine-guide-back" :to="localePath('/wine-guide/usa/sonoma')"></nuxt-link>
                        Producers
                    </div>
                    <v-select
                        :items="items"
                        v-model="select"
                        label="Please choose"
                        single-line
                        item-text="report"
                        item-value="src"
                        return-object
                        class="show-mobile show-mobile-select"
                        v-on:change="changeRoute"
                    ></v-select>
                </div>
                <div v-if="$i18n.locale === 'it'" class="wine-guide-right">
                    <div class="howto-title">Verite Vigneron</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        Pierre Seillan di Verite Vigneron ha molte mani in molte torte. Vale a dire, il
                        enologo ha partecipazioni a Bordeaux, in California e in Toscana. Tre regioni molto diverse significano
                        tre vini molto diversi ma il suo cuore risiede, non nella sua nativa Francia come ci si potrebbe aspettare, ma
                        piuttosto nella Sonoma Valley, dove produce vini piuttosto buoni da oltre 30 anni.
                    </div>

                    <div class="howto-title2">Un cowboy francese</div>
                    <div class="howto-text">
                        Enologo di settima generazione, era naturale che Pierre Seillan portasse avanti il
                        tradizione familiare. Dopo uno stage a Temecula, Seillan ha deciso che Napa, con il suo caldo, caldo
                        estati, non sarebbe la scelta ideale per produrre i raffinati vini in stile bordolese che tanto desiderava,
                        e tornò rapidamente in Francia. Due decadi e sette castelli dopo, un invito di Jess
                        Jackson lo attirò a Sonoma con le sue fresche brezze del Pacifico. All'epoca (anni '90), califoniano
                        i vini erano principalmente Cabernet Sauvignon monovitigno e alcuni Pinot Noir, e Seillan iniziò
                        sperimentando con Cabernet Franc, Malbec e Petit Verdot. I cosiddetti “terroristi di
                        Sonoma", Jackson e Seillan hanno promosso la superba topografia e la varietà dei suoli della regione, non il
                        tipico stile californiano. Oggi è un distintivo che indossa ancora con orgoglio.
                    </div>

                    <div class="howto-title2">In vino veritas</div>
                    <div class="howto-text">
                        Sembra che quello che era iniziato come un azzardo abbia dato i suoi frutti. Nel 1998 la coppia ha pubblicato La Muse,
                        una miscela a base di Merlot ispirata al Pomerol; e La Joie, Cabernet Sauvignon prodotto a Pauillac
                        stile; (seguito da Le Désir nel 2000, un Cabernet Franc simile a Saint-Émilion). Questi
                        i vini di classe mondiale sono alcune delle migliori espressioni di queste uve nel mondo e riflettono il
                        terroir unico di Sonoma. Chiaramente un successo, Robert Parker ha dato un enorme successo a 13 delle sue annate
                        100 punti, mentre altri raggiungono costantemente gli anni '90 anno dopo anno. Di questi, La Muse, con
                        la sua produzione minuscola (4.000 casse) e l'invecchiamento superlativo (fino a 40+ anni per una migliore
                        annate) mostra i migliori ritorni sugli investimenti, con un aumento superiore alla media del 24% in 24 mesi
                        da maggio 2017.
                    </div>
                </div>
                <div v-else-if="$i18n.locale === 'de'" class="wine-guide-right">
                    <div class="howto-title">Verite Vigneron</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        Pierre Seillan von Verite Vigneron hat viele Finger in vielen Kuchen. Das heißt, die
                        Der Winzer verfügt über Beteiligungen in Bordeaux, Kalifornien und der Toskana. Drei sehr unterschiedliche Regionen bedeuten
                        drei sehr unterschiedliche Weine, aber sein Herz liegt nicht in seiner Heimat Frankreich, wie man erwarten könnte, sondern
                        vielmehr im Sonoma Valley, wo er seit über 30 Jahren recht gute Weine herstellt.
                    </div>

                    <div class="howto-title2">Ein französischer Cowboy</div>
                    <div class="howto-text">
                        Als Winzer in siebter Generation war es nur natürlich, dass Pierre Seillan das Weingut weiterführte
                        Familien tradition. Nach einem Praktikum in Temecula beschloss Seillan, dass es in Napa heiß, heiß ist
                        Sommer, wäre nicht die ideale Wahl, um die raffinierten Weine im Bordeaux-Stil herzustellen, die er so sehr wollte,
                        und er kehrte schnell nach Frankreich zurück. Zwei Jahrzehnte und sieben Schlösser später, eine Einladung von Jess
                        Jackson lockte ihn mit der kühlenden Pazifikbrise nach Sonoma. Damals (in den 1990er Jahren) kalifornisch
                        Die Weine bestanden hauptsächlich aus sortenreinen Cabernet Sauvignons und einigen Pinot Noirs, und Seillan begann
                        Experimentieren mit Cabernet Franc, Malbec und Petit Verdot. Sogenannte „Terroristen von“.
                        Sonoma“, bewarben Jackson und Seillan die hervorragende Topographie und die vielfältigen Böden der Region, nicht die
                        typischer kalifornischer Stil. Heute ist es ein Abzeichen, das er immer noch mit Stolz trägt.
                    </div>

                    <div class="howto-title2">In vino veritas</div>
                    <div class="howto-text">
                        Es scheint, dass sich das, was als Wagnis begann, ausgezahlt hat. 1998 veröffentlichte das Paar La Muse,
                        eine Mischung auf Merlot-Basis, inspiriert von Pomerol; und La Joie, Cabernet Sauvignon, hergestellt im Pauillac
                        Stil; (im Jahr 2000 folgte Le Désir, ein Cabernet Franc ähnlich dem Saint-Émilion). Diese
                        Weltklasse-Weine gehören zu den besten Ausdrucksformen dieser Trauben auf der Welt und spiegeln die Qualität wider
                        einzigartiges Terroir von Sonoma. Offensichtlich ein Erfolg, Robert Parker gab 13 seiner Jahrgänge eine satte Note
                        100 Punkte, während andere Jahr für Jahr konstant die hohen 90er erreichen. Davon La Muse, mit
                        Seine winzige Produktion (4.000 Kisten) und seine hervorragende Alterung (bis zu 40+ Jahre).
                        Jahrgänge) weisen mit einem überdurchschnittlichen Anstieg von 24 % in 24 Monaten die besten Anlagerenditen auf
                        ab Mai 2017.
                    </div>
                </div>
                <div v-else-if="$i18n.locale === 'fr'" class="wine-guide-right">
                    <div class="howto-title">Verite Vigneron</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        Pierre Seillan de Verite Vigneron a beaucoup de doigts dans beaucoup de tartes. C'est-à-dire, le
                        Le vigneron possède des exploitations à Bordeaux, en Californie et en Toscane. Trois régions très différentes signifient
                        trois vins très différents mais son cœur n'est pas dans sa France natale comme on pourrait s'y attendre, mais
                        plutôt dans la vallée de Sonoma, où il produit d'assez bons vins depuis plus de 30 ans.
                    </div>

                    <div class="howto-title2">Un cow-boy français</div>
                    <div class="howto-text">
                        Viticulteur à la septième génération, c'est tout naturellement que Pierre Seillan poursuivra la
                        tradition familiale. Après un stage à Temecula, Seillan a décidé que Napa, avec son chaud, chaud
                        étés, ne serait pas le choix idéal pour élaborer les vins raffinés de style bordelais qu'il souhaitait tant,
                        et il rentre rapidement en France. Deux décennies et sept châteaux plus tard, une invitation de Jess
                        Jackson l'a attiré à Sonoma avec ses brises rafraîchissantes du Pacifique. A l'époque (les années 1990), la Californienne
                        les vins étaient principalement des cabernets sauvignons à cépage unique et quelques pinots noirs, et Seillan a commencé
                        expérimentant le cabernet franc, le malbec et le petit verdot. Les soi-disant « terroristes de
                        Sonoma », Jackson et Seillan ont mis en avant la superbe topographie et les sols variés de la région, pas la
                        style typiquement californien. Aujourd'hui, c'est un insigne qu'il porte toujours avec fierté.
                    </div>

                    <div class="howto-title2">In vino veritas</div>
                    <div class="howto-text">
                        Il semble que ce qui a commencé comme un pari a porté ses fruits. En 1998, le duo sort La Muse,
                        un assemblage à base de Merlot inspiré de Pomerol ; et La Joie, Cabernet Sauvignon fait à Pauillac
                        style; (suivi par Le Désir en 2000, un cabernet franc proche du Saint-Émilion). Ces
                        les vins de classe mondiale sont parmi les meilleures expressions de ces raisins dans le monde et reflètent la
                        terroir unique de Sonoma. Clairement un succès, Robert Parker a donné 13 de ses millésimes un énorme
                        100 points tandis que d'autres atteignent systématiquement le sommet des 90 année après année. Parmi ceux-ci, La Muse, avec
                        sa production minuscule (4 000 caisses) et son vieillissement superlatif (jusqu'à 40 ans et plus pour une meilleure
                        millésimes) affiche les meilleurs retours sur investissement, avec une hausse supérieure à la moyenne de 24 % en 24 mois
                        à partir de mai 2017.
                    </div>
                </div>
                <div v-else class="wine-guide-right">
                    <div class="howto-title">Verite Vigneron</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        Pierre Seillan of Verite Vigneron has a lot of fingers in a lot of pies. That is to say, the
                        winemaker has holdings in Bordeaux, California and Tuscany. Three very different regions mean
                        three very different wines but his heart lies, not in his native France as one might expect, but
                        rather in the Sonoma Valley, where he has been making rather good wines for over 30 years.
                    </div>

                    <div class="howto-title2">A french cowboy</div>
                    <div class="howto-text">
                        A seventh-generation winemaker, it was only natural that Pierre Seillan would carry on the
                        family tradition. After an internship in Temecula, Seillan decided that Napa, with its hot, hot
                        summers, would not be the ideal choice to make the refined Bordeaux-style wines he so wanted,
                        and he quickly returned to France. Two decades and seven chateaux later, an invitation by Jess
                        Jackson drew him to Sonoma with its cooling Pacific breezes. At the time (the 1990s), Califonian
                        wines were mainly single varietal Cabernet Sauvignons and some Pinot Noirs, and Seillan started
                        experimenting with Cabernet Franc, Malbec, and Petit Verdot. So called the “terrorists of
                        Sonoma”, Jackson and Seillan promoted the region’s superb topography and varied soils, not the
                        typical California style. Today it is a badge he still wears with pride.
                    </div>

                    <div class="howto-title2">In vino veritas</div>
                    <div class="howto-text">
                        It seems that what started as a bit of a gamble has paid off. In 1998 the pair released La Muse,
                        a Merlot-based blend inspired by Pomerol; and La Joie, Cabernet Sauvignon made in the Pauillac
                        style; (followed by Le Désir in 2000, a Cabernet Franc similar to Saint-Émilion). These
                        world-class wines are some of the best expressions of these grapes in the world and reflect the
                        unique terroir of Sonoma. Clearly a success, Robert Parker gave 13 of his vintages a whopping
                        100-points while others consistently hit the high 90s year after year. Of these, La Muse, with
                        its minuscule (4,000 case) production and superlative ageing (up to 40+ years for better
                        vintages) shows the best returns on investment, with an above average rise of 24% in 24-months
                        from May 2017.
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "VeriteVigneron",
    head: {
        title: 'Verite Vigneron | Vindome Wine Guide',
        meta: [
            {
                hid: 'description',
                name: 'description',
                content: 'Discover the exceptional quality of Verite Vigneron, a leading wine producer in the Napa Valley known for their handcrafted, limited production wines made from the finest grapes. Experience the art of winemaking at its finest with Verite Vigneron.'
            }
        ],
        bodyAttrs: {
            class: 'wine-guide inner-page'
        }
    },
    data() {
        return {
            select: {report: 'Verite Vigneron', src: '/wine-guide/usa/sonoma/verite-vigneron'},
            items: [
                {report: 'Ridge Vineyards', src: '/wine-guide/usa/sonoma/ridge-vineyards'},
                {report: 'Sine Qua Non', src: '/wine-guide/usa/sonoma/sine-qua-non'},
                {report: 'Verite Vigneron', src: '/wine-guide/usa/sonoma/verite-vigneron'}
            ]
        }
    },
    methods: {
        changeRoute(a) {
                this.$router.push({path: this.localePath(a.src) });
            }
    }
}
</script>

<style scoped>
.container {
    max-width: 1170px;
    padding: 0;
    font-family: 'Poppins', sans-serif;
}
.wine-guide-body {
    padding-top: 35px;
}
.wine-guide-left {
    width: 300px;
    display: inline-block;
}
.wine-guide-right {
    display: inline-block;
    width: calc(100% - 305px);
    vertical-align: top;
}
.wine-guide-left-title {
    font-weight: 600;
    color: #024E7B;
    font-size: 18px;
    height: 57px;
    line-height: 57px;
}
.wine-guide-country {
    display: block;
    height: 57px;
    line-height: 57px;
    text-decoration: none;
    color: #000;
    font-size: 16px;
    padding-left: 30px;
    width: 260px;
    border-left: 3px solid transparent;
}
.wine-guide-country:hover,
.wine-guide-country.active {
    border-color: #024E7B;
    background: #E5EDF2;
}
</style>
